import { render, staticRenderFns } from "./PatentDemandAdd.vue?vue&type=template&id=c4d70658&scoped=true&"
import script from "./PatentDemandAdd.vue?vue&type=script&lang=js&"
export * from "./PatentDemandAdd.vue?vue&type=script&lang=js&"
import style0 from "./PatentDemandAdd.vue?vue&type=style&index=0&id=c4d70658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d70658",
  null
  
)

export default component.exports